export function isUndergroundMapV2(mapData) {
  return mapData.hasOwnProperty('meta');
}